export default "__VITE_ASSET__ae560ce6__"